import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.span`
    display: inline-block;
    vertical-align: middle;
    margin: 3px 0;
    height: 30px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

const StyledCheckbox = styled.span`
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #333333;
    background: #ffffff;
    border-radius: 3px;
    font-weight: bold;
    font-size: 1.4rem;
    margin: 3px 0;
    &:focus {
        background: #fffee0;
    }
`;

interface IProps {
    ariaLabel?: string,
    className?: string,
    checked: boolean,
    onChange: (isChecked: boolean) => void
};

const Checkbox = (props: IProps) => {
    const { ariaLabel, className, checked, onChange } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === " ") {
            onChange(!checked);
            event.stopPropagation();
            event.preventDefault();
        }
    };

    return <CheckboxContainer className={className}>
        <HiddenCheckbox checked={checked} onChange={handleChange} tabIndex={-1} />
        <StyledCheckbox tabIndex={0} onKeyDown={handleKeyDown} aria-label={ariaLabel} aria-checked={checked}>
            {checked && "X"}
        </StyledCheckbox>
    </CheckboxContainer>;
};

export default Checkbox



// WEBPACK FOOTER //
// ./src/SharedComponents/Checkbox.tsx